<template>
  <div class="client_request_btn shadow-sm">
    <button @click="openDrawer" class="btn btn-outline-info"><i class="icon-fa icon-fa-user-plus"/></button>
  </div>
</template>

<script>
export default {
  methods: {
    openDrawer() {
      this.$store.dispatch('platform/setGlobalDrawerData', {
        data: {
          data: {
            client: {},
            call: {},
            searchClient: true,
          },
          drawer: {small: true},
          type: 'ClientIncomeRequest',
        },
      });
    }
  }
}
</script>
<style scoped>
.client_request_btn {
  position: fixed;
  right: 0;
  top: 50%;
  background-color: white;
  z-index: 1;
  padding: 2px;
}
</style>
